<div class="breadcrumb-block">
    <div class="list">
        <p *ngFor="let list of items;let last = last">{{list.label}} <span *ngIf="!last"> / </span></p> 
    </div>
</div> 